<template>
  <table class="table table-hover table-responsive table-striped">
    <thead>
      <tr>
        <th>ردیف</th>
        <th>نام</th>
        <th>تلفن</th>
        <th>سمت</th>
        <th>وضعیت</th>
        <th>جایگزینی</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in members" :key="item.id">
        <td>{{ index + 2 }}</td>
        <td>
          <span v-if="!item.member"> --- </span>
          <span v-else>
            {{
              (item.member.first_name ? item.member.first_name + " " : "") +
              item.member.last_name
            }}
          </span>
        </td>
        <td>{{ item.mobile }}</td>
        <td>
          <span v-if="+item.isCreator === 1">سازنده </span>
          <span v-else>عضو تیم</span>
        </td>
        <td>
          <span v-if="item.is_verified">
            تایید شده
            <i class="fas fa-check me-1 text-success"></i>
          </span>
          <span v-else>
            در انتظار تایید
            <i class="fas fa-window-close text-danger"></i>
          </span>
        </td>
        <td>
          <span v-if="!item.is_verified">
            <button
              class="btn btn-danger btn-sm"
              @click="deleteMemberConfirm(item.id)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
          <span v-else></span>
        </td>
      </tr>
      <tr>
        <td>{{ 3 }}</td>
        <td>
          {{
            (leader.first_name ? leader.first_name + " " : "") +
            leader.last_name
          }}
        </td>
        <td>{{ leader.email }}</td>
        <td>
          <span>سازنده </span>
        </td>
        <td>
          <span>
            تایید شده
            <i class="fas fa-check me-1 text-success"></i>
          </span>
        </td>
        <td></td>
      </tr>
    </tbody>
  </table>
  <div v-if="members.length < 2" class="row">
    <div class="col-6 form-floating mb-3">
      <input
        v-model="newMemberNumber"
        type="text"
        class="form-control"
        placeholder="تلفن همراه عضو "
      />
      <label> افزودن تلفن همراه عضو جدید *</label>
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
    </div>
    <div class="col-2 mt-3">
      <button
        class="btn btn-primary w-100"
        @click="addNumber(teamUserId, newMemberNumber)"
        :disabled="loading"
      >
        ثبت
      </button>
    </div>
  </div>
</template>
<script>
import ArefApi from "@/libs/api.js";
import utils from "@/libs/utils";

export default {
  props: {
    members: {
      type: Array,
    },
    leader: {
      type: Object,
    },
    teamUserId: {
      type: Number,
    },
  },
  emits: {
    reloadList: Function,
  },
  data() {
    return {
      newMemberNumber: null,
      error: null,
      loading: false,
    };
  },
  created: function () {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
  },
  methods: {
    addNumber(teamUserId, newMemberNumber) {
      this.error = null;
      if (!newMemberNumber) {
        this.error = "تلفن را صحیح وارد کنید";
        return;
      }
      if (!this.utils.validMobile(newMemberNumber)) {
        this.error = "تلفن را صحیح وارد کنید.";
        return;
      }

      this.loading = true;
      const addObj = {
        team_user_id: teamUserId,
        mobile: newMemberNumber,
      };
      this.arefApi
        .addATeamMember(addObj)
        .then(() => {
          this.utils.showSuccess(this);
          this.newMemberNumber = null;
          this.$emit("reloadList");
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteMemberConfirm(team_user_member_id) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.deleteMember(team_user_member_id);
          }
        });
    },
    deleteMember(team_user_member_id) {
      this.arefApi
        .deleteATeamMember(team_user_member_id)
        .then(() => {
          this.$emit("reloadList");
          this.utils.showSuccess(this, "حذف با موفقیت انجام شد");
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
  },
};
</script>